import React from "react";
import layer_4 from '../assets/images/landingpageman.png';
import Banner from "./Banner"; 
import Header from "../components/layout/Header";

function Landhead() {
  
 
  

  return (
            <div className="header">
                <Banner />
                <Header />
                
                <img src={layer_4} className="layer-4" alt="layer_4" width="366" height="332"/>
                 
            </div>
           

    );
}

export default Landhead;
